import { Button } from "@/components/ui/button";

type CookieConsentBannerProps = {
  onAcceptAll: () => void;
  onCustomize: () => void;
  onRejectOptional: () => void;
};

export default function CookieConsentBanner({
  onAcceptAll,
  onCustomize,
  onRejectOptional,
}: CookieConsentBannerProps) {
  return (
    <aside
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-border bg-background/95 px-3 pb-[calc(env(safe-area-inset-bottom)+0.5rem)] pt-2.5 shadow-2xl backdrop-blur sm:px-4 sm:pb-[calc(env(safe-area-inset-bottom)+1rem)] sm:pt-4"
      role="region"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-2.5 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-3xl">
          <h2 className="text-sm font-bold text-foreground sm:text-base">Your privacy choices</h2>
          <p className="mt-1 text-xs leading-5 text-muted-foreground sm:mt-1.5 sm:text-sm sm:leading-6">
            Necessary technologies keep JusticeDrive working. Optional analytics and advertising technologies help us
            measure usage and campaign performance. Read our{" "}
            <a className="font-medium text-blue-800 hover:underline" href="/cookie-policy/">
              Cookie Policy
            </a>{" "}
            and{" "}
            <a className="font-medium text-blue-800 hover:underline" href="/privacy/">
              Privacy Policy
            </a>
            .
          </p>
        </div>
        <div className="grid grid-cols-1 gap-2 min-[430px]:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] sm:grid-cols-3 lg:min-w-[28rem]">
          <Button className="h-9 min-w-0 px-2 text-[11px] sm:h-10 sm:text-sm" onClick={onAcceptAll} type="button">
            Accept all
          </Button>
          <Button className="h-9 min-w-0 px-2 text-[11px] sm:h-10 sm:text-sm" onClick={onRejectOptional} type="button" variant="outline">
            Reject optional
          </Button>
          <Button className="h-9 min-w-0 px-2 text-[11px] min-[430px]:col-span-2 sm:col-span-1 sm:h-10 sm:text-sm" onClick={onCustomize} type="button" variant="secondary">
            Customize
          </Button>
        </div>
      </div>
    </aside>
  );
}
